import { Component} from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { gridPageRequest, Product, SalesOrder,UpdateInventory } from '../../../model/common/common.model';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { LoaderComponent } from '../../loader/loader.component';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { SalesService } from '../../../services/sales.service';
import { ElementRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService} from 'primeng/dynamicdialog';
import { CustomerService } from '../../../services/customer.service';
import { InventoryService } from '../../../services/inventory.service';
import { AdministratorService } from '../../../services/administrator.service';
import { Warehouse } from '../../../model/administration.model';
import _ from 'lodash';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
@Component({
  selector: 'app-viewinvoiceproduct-lookup',
  standalone: true,
  imports: [SharedModule, CommonModule, LoaderComponent, TieredMenuModule],
  providers: [MessageService],
  templateUrl: './viewinvoiceproduct-lookup.component.html',
  styleUrls: ['./viewinvoiceproduct-lookup.component.scss'],
})
export class viewinvoiceproductLookupComponent{

  userList: any;
  deliveryDate: any | undefined;
  productTableData: any[] = [];

  constructor(private router: Router, private messageService: MessageService, private customerService: CustomerService, private administratorService: AdministratorService,
    public dialogService: DialogService, public ref: DynamicDialogRef, private inventoryService: InventoryService, private salesService: SalesService, private el: ElementRef, private confirmationService: ConfirmationService,
    private route: ActivatedRoute) { }

  loader: boolean = false;
  isEdit: boolean = false;
  isIGST: boolean = false;
  submitted: boolean = false;
  activeIndex: number = 0;
  selectedCustomerEmail: string | null = null;
  selectedCustomerName: string | null = null;
  isEditingQuantity: boolean = false;
  isEditingWeight: boolean = false;
  previewImage: string = "./assets/no-image.jpg";
  productCostCalculationType: string | undefined;

  createOrderForm = new FormGroup({
    OrderNo: new FormControl('', Validators.required),
    manualEntry: new FormControl(false),
    BillToCustomerId: new FormControl('', Validators.required),
    ShipToCustomerId: new FormControl('', Validators.required),
    BillToCustomerCode: new FormControl('', Validators.required),
    ShipToCustomerCode: new FormControl('', Validators.required),
    BillToCustomer: new FormControl('', Validators.required),
    ShipToCustomer: new FormControl('', Validators.required),
    BillToCustomerAddress: new FormControl(''),
    ShipToCustomerAddress: new FormControl('', Validators.required),
    warehouse: new FormControl('', Validators.required),
    WareHouseId: new FormControl('', Validators.required),
    salesperson: new FormControl('', Validators.required),
    SalespersonCode: new FormControl('', Validators.required),
    SalespersonId: new FormControl('', Validators.required),
    CreatedBy: new FormControl('', Validators.required),
    // add product
    SalesTax:new FormControl(''),
    CustomerName:new FormControl(''),
    productId: new FormControl(''),
    productCode: new FormControl(''),
    productDescription: new FormControl(''),
    productQty: new FormControl(''),
    productWgt: new FormControl(''),
    productData: new FormControl(''),
    totalWeight: new FormControl(),
    ShipmentDate: new FormControl(),
    TermsCode: new FormControl(''),
    DispatchDocNo: new FormControl(''),
    MotorVehicalNo: new FormControl(),
    BillOfLading: new FormControl(),
    LRRRNo: new FormControl(),
    DispatchThrough: new FormControl(),
    // OrderType: new FormControl('Q'),

    BillToCustomerState: new FormControl(''),
    warehouseState: new FormControl(''),

    requestedDate: new FormControl(),
    orderDate: new FormControl(),
    deliveryNote: new FormControl('')


  });

  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 100,
    id: 0
  }

  BillTocustomerList: any[] = [];
  ShipTocustomerList: any[] = [];
  warehouseDropdown: Warehouse[] = [];
  filterProductList: any[] = [];
  products: Product[] = [];    // Main product variable
  allProductData: Product[] = []; // Stores all product data even after deleting from the grid
  addProductData: any;        // Represents data for adding a new product
  selectedProduct: Product[] = [];   // // Stores data for deleted products
  deleteProductIds: any[] = [];

  orderTotal: number = 0.00;
  weightTotal: number = 0.00;
  CGSTtotal: number = 0.00;
  SGSTtotal: number = 0.00;
  IGSTtotal: number = 0.00;
  SalesTaxTotal: number = 0.00;
  Taxable: number = 0.00;

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      if (params['productData']) {
        this.isEdit = true;
        this.reOpen();
      } else {
        this.isEdit = false;
      }
    });
    this.createOrderForm.controls.CreatedBy.setValue(localStorage.getItem('username'));
    this.createOrderForm.controls.orderDate.setValue(new Date());
    this.createOrderForm.controls.requestedDate.setValue(new Date());
    const currentDate = new Date();
    this.deliveryDate = currentDate;

    if (this.isEdit) {
      this.createOrderForm.controls['orderDate'].disable();
    } else {
      this.createOrderForm.controls['orderDate'].enable();
    }
  }

  
 
  reOpen() {
    this.route.queryParams.subscribe(params => {
      try {
        const productData = JSON.parse(params['productData']);
        const salesOrderLineItemId = productData.salesOrderLineItemId;
        this.salesService.getSalesOrderLineItemById(salesOrderLineItemId).subscribe({
          next: (productDetails: Product) => {
            if (productDetails) {
              this.createOrderForm.patchValue({
                OrderNo: productData.salesOrderNumber,
                SalesTax: productData.salesTax,
              });

              this.productTableData = [{
                productCode: productData.productCode,
                productDescription: productData.productDescription,
                unitPrice: productData.unitPrice,
                salesTax: productData.salesTax,
                uom: productData.uom,
                salesOrderNumber: productData.salesOrderNumber,
                salesOrderLineItemId: productData.salesOrderLineItemId,
                shippedQuantity: productData.shipedQuantity,
                createdDate:productData.createdDate,
                customerName:productData.customerName,
              }];
              this.deliveryDate = productData.requestedDate;
              this.orderTotal = productData.orderTotal;
              this.weightTotal = productData.totalWeight;
              this.SalesTaxTotal = productData.salesTaxTotal;
              this.CGSTtotal = productData.cgstTotal;
              this.SGSTtotal = productData.sgstTotal;
              this.IGSTtotal = productData.igstTotal;
            }
          },
          error: (error: any) => {
            console.error('Error fetching product details', error);
            this.loader = false;
          }
        });
      } catch (error) {
        console.error('Error parsing product data:', error);
      }
    });
  }
  exportData(): void {
    const pdfTable = document.getElementById('pdf-table');
    if (!pdfTable) {
      console.error('Table not found!');
      return;
    }

    html2canvas(pdfTable, { scale: 2 }).then((canvas: HTMLCanvasElement) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('l', 'pt', 'a4'); // Landscape orientation

      // Add invoice header
      pdf.setFontSize(18);
      const headerText = 'Invoice Report';
      const headerWidth = pdf.getTextWidth(headerText);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const headerX = (pdfWidth - headerWidth) / 2;
      pdf.text(headerText, headerX, 30);

      // Add footer with generated date
      pdf.setFontSize(10);
      const footerText = `Generated on: ${new Date().toLocaleDateString()}`;
      pdf.text(footerText, 40, pdf.internal.pageSize.getHeight() - 20);

      // Prepare image data
      const imgWidth = pdf.internal.pageSize.getWidth() - 80; // Leave margin
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let heightLeft = imgHeight;
      let position = 40;

      // Add the image to the first page
      pdf.addImage(imgData, 'PNG', 40, position, imgWidth, imgHeight);
      heightLeft -= pdf.internal.pageSize.getHeight();

      // Handle page breaks if content exceeds one page
      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', 40, position, imgWidth, imgHeight);
        heightLeft -= pdf.internal.pageSize.getHeight();
      }

      // Save the generated PDF
      pdf.save('invoice_report.pdf');
    }).catch((error) => {
      console.error('Error generating PDF:', error);
    });
  }
}